import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { RxUpdate } from 'react-icons/rx';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import AcademiaButton from '../../CommonComps/Buttons/AcademiaButton';
import AddEditRolePermissionModal from '../../CommonComps/Modals/AddEditRolePermissionModal';

const MutateRolePermissionAction = ({
  hasCreatePermission,
  hasUpdatePermission,
}: {
  hasCreatePermission: boolean;
  hasUpdatePermission: boolean;
}) => {
  // integration of react hooks here
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  // rendering mutate role permission action component here
  return (
    <>
      <div className='w-full 2xl:w-2/5 flex flex-col md:flex-row items-center justify-center gap-4'>
        <AcademiaButton
          title={
            !hasUpdatePermission ? 'You do not have permissions!' : undefined
          }
          type='button'
          onClick={() => setShowEditModal(true)}
          variant='premium'
          icon={<RxUpdate className='size-6' />}
          additionalClassNames='!w-full md:w-fit'
          isDisabled={!hasUpdatePermission}
        >
          Update Permission
        </AcademiaButton>

        <AcademiaButton
          title={
            !hasCreatePermission ? 'You do not have permissions!' : undefined
          }
          type='button'
          onClick={() => setShowCreateModal(true)}
          variant='info'
          icon={<TbSquareRoundedPlusFilled className='size-6' />}
          additionalClassNames='!w-full md:w-fit'
          isDisabled={!hasCreatePermission}
        >
          Add Permission
        </AcademiaButton>
      </div>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showCreateModal && (
          <AddEditRolePermissionModal
            title='add'
            handleModalClose={() => setShowCreateModal(false)}
          />
        )}
      </AnimatePresence>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showEditModal && (
          <AddEditRolePermissionModal
            title='update'
            handleModalClose={() => setShowEditModal(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default MutateRolePermissionAction;
